import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Check } from 'lucide-react';

const themeColors = {
  teal: { primary: '#14b8a6', dark: '#0d9488', accent: '#fbbf24' },
  indigo: { primary: '#6366f1', dark: '#4f46e5', accent: '#34d399' },
  slate: { primary: '#64748b', dark: '#475569', accent: '#60a5fa' },
};

export default function ThemeSelector() {
  const { theme, setTheme, themes } = useTheme();

  return (
    <div className="space-y-3">
      <p className="text-sm text-gray-600 mb-4">
        Choisissez le thème de couleurs de l'application
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {Object.values(themes).map((t) => {
          const colors = themeColors[t.id];
          const isActive = theme === t.id;
          return (
            <button
              key={t.id}
              onClick={() => setTheme(t.id)}
              className={`relative p-4 rounded-xl border-2 transition-all text-left ${
                isActive
                  ? 'border-gray-800 shadow-md'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              {isActive && (
                <span className="absolute top-2 right-2 w-5 h-5 rounded-full bg-gray-800 flex items-center justify-center">
                  <Check size={12} className="text-white" />
                </span>
              )}
              <div className="flex gap-2 mb-3">
                <span
                  className="w-8 h-8 rounded-full"
                  style={{ backgroundColor: colors.primary }}
                />
                <span
                  className="w-8 h-8 rounded-full"
                  style={{ backgroundColor: colors.dark }}
                />
                <span
                  className="w-8 h-8 rounded-full"
                  style={{ backgroundColor: colors.accent }}
                />
              </div>
              <p className="font-medium text-sm text-gray-900">{t.name}</p>
              <p className="text-xs text-gray-500">{t.description}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
